import React from "react";
import ReactDOM from "react-dom/client";

// Fonts are bundled from npm, never linked from a CDN (§14).
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "@fontsource/instrument-serif/400.css";
import "@fontsource/instrument-serif/400-italic.css";

import App from "@/App";
import { isNative } from "@/platform";
import { loadAuthToken } from "@/platform/session";
import "@/styles/index.css";

const render = () =>
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

// The Android app reads its sign-in token from encrypted storage before the
// first request; a browser has none and renders at once, as it always did.
if (isNative()) void loadAuthToken().finally(render);
else render();
